module.exports = __webpack_public_path__ + "static/media/eric-avergonzado.e2190e93.png";